import { Col, Row } from "react-bootstrap";

export default function Input({
  label,
  labelClass,
  inputType,
  required,
  register,
  id,
  name,
  error,
  ...props
}) {
  return (
    <Row>
      <Col md={{offset: 1, span: 4}} className="d-flex align-items-center">
        <label htmlFor={id}>
          {label}: {required && <span className="required">*</span>}
        </label>
      </Col>
      <Col md={6} className="d-grid gap-2">
        <input
          type={inputType}
          className={error ? "text-error" : "text"}
          id={id}
          {...register(name)}
          {...props}
        />
        {/* <div className="control-error">{error && <p>{error}</p>}</div> */}
        <span className="required">{error && <p>{error}</p>}</span>
      </Col>
    </Row>
  );
}
